import * as React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const SwitcherooIcon = (props: IconProps): JSX.Element => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 105 85" {...props}>
      <path
        fill="currentColor"
        d="M2.2 41.7l20.2-20.1a1.7 1.7 0 012.3 2.3L7.4 41.3h54.9a1.7 1.7 0 010 3.3H7.4L24.7 62a1.7 1.7 0 01-2.3 2.4L2.2 44.1c-.7-.6-.7-1.7 0-2.4z"
      />
      <path
        fill="currentColor"
        d="M95.4 55.2L75.2 35a1.7 1.7 0 00-2.4 2.4l17.4 17.3H35.3a1.7 1.7 0 000 3.4h54.9L72.8 75.4a1.7 1.7 0 002.4 2.4l20.2-20.2c.7-.7.7-1.7 0-2.4z"
      />
    </Icon>
  );
};
